module.exports = __webpack_public_path__ + "static/media/title.210e2100.png";